//Preferences
export const ATTESTATION_PREFERENCE = 'ACCEPTED_PRACTICE_EXAM_TOC';
export const ATTESTATION_SUBJECT = 'SUBJECT';

export const QuestionTypes = {
  FREE_RESPONSE_QUESTION: 'FreeResponseQuestion',
  MULTIPLE_CHOICE_QUESTION: 'MultipleChoiceQuestion',
};
